import { render, staticRenderFns } from "./PoliticasView.vue?vue&type=template&id=1bfc4a65"
import script from "./PoliticasView.vue?vue&type=script&lang=js"
export * from "./PoliticasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports